import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import ReturnReasonSidebar from '../../react-components/ReturnReasonSidebar';
import { store } from '../../store';

export const renderReturnReasonSidebar = ({ handlers, node }) => {
  render(
    <Provider store={store}>
      <ReturnReasonSidebar
        sidebarState={store.getState().returnReasonSidebar}
        handlers={handlers}
      />
    </Provider>,
    node,
  );
};
